import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { NotFoundPage } from 'app/components/NotFoundPage';
import { Login } from 'app/pages/LoginPage';

import SignUp from 'app/pages/SignUp';
import Layout from 'app/components/Layout';
import PrivateRoute from './PrivateRoute';
import { ROLE } from 'constant/user';
import { router, menuConfig } from 'constant/router';
import { HomePage } from 'app/pages/HomePage';

export function RouterApp() {
  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path={router.login} component={Login} />
          <Route exact path={router.sign_up} component={SignUp} />
          <Route exact path={router.not_found_page} component={NotFoundPage} />
          <PrivateRoute
            exact
            path={router.home}
            component={HomePage}
            roles={[ROLE.superAdmin, ROLE.user]}
          />
          {Object.entries(menuConfig).map(([key, value]) => (
            <PrivateRoute
              key={key}
              exact
              path={value.router}
              component={value.component ? value.component : NotFoundPage}
              roles={value?.role || []}
            />
          ))}
        </Switch>
      </Layout>
    </Router>
  );
}
